var React = require('react');

function FlagBe (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M170.667 423.721H8.828A8.829 8.829 0 010 414.893V97.1a8.829 8.829 0 018.828-8.828h161.839v335.449z","fill":"#464655","key":0}),React.createElement("path",{"fill":"#ffe15a","d":"M170.67 88.277h170.67v335.45H170.67z","key":1}),React.createElement("path",{"d":"M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 01512 97.101v317.793a8.827 8.827 0 01-8.828 8.827z","fill":"#ff4b55","key":2})]);
}

FlagBe.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagBe;

FlagBe.default = FlagBe;
